import React from "react";
import ReactDOM from 'react-dom';
import Root from './pages/Root';
import {AppContainer} from 'react-hot-loader';
import './i18n/i18n';
import store from './store/store'
// Společná inicializace aplikace - polyfill apod.
import 'url-search-params-polyfill';
// Import css Bootstrapu
import 'font-awesome/css/font-awesome.css'
import 'marbes-iconfont/css/mif.less';
import './app-styles.scss';
// CSS pro react-tippy
import 'react-tippy/dist/tippy.css';
import {baseAxios} from "@mc/axios-api";
import {legacyStandardErrorInterceptor} from "@mc/mc-legacy";

baseAxios.interceptors.response.use(undefined, legacyStandardErrorInterceptor);

const render = Component => {
    const MOUNT_POINT = document.getElementById('root');
    ReactDOM.render(
        <AppContainer>
            <Component store={store} />
        </AppContainer>,
        MOUNT_POINT
    )
};

render(Root);

if (module.hot) {
    module.hot.accept('./pages/Root', () => render(Root));
}
